<template>
  <lb-dialog
    :value="value"
    @input="$emit('input', $event)"
    :heading="heading"
    width="420"
    :data-testid="dataTestid + '__delete-dialog'"
  >
    <template v-slot:body>
      <div class="py-2">
        <p class="body-1 font-weight-semibold mb-1">{{ message }}</p>
        <p class="body-2 text--secondary mb-0" v-if="subMessage" v-html="subMessage" />
      </div>
    </template>
    <template v-slot:actions>
      <base-button
        label="Cancel"
        outlined
        :data-testid="dataTestid + '__delete-cancel-btn'"
        @click="$emit('input', false)"
      />
      <base-button
        label="Yes, Delete"
        reject-filled
        class="ml-2"
        :data-testid="dataTestid + '__delete-confirm-btn'"
        @click="$emit('confirm')"
      />
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'ConfirmDeleteDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: 'Confirm Delete',
    },
    message: {
      type: String,
      default: 'Are you sure you want to delete this item?',
    },
    subMessage: {
      type: String,
      default: 'This action cannot be undone.',
    },
    dataTestid: {
      type: String,
      default: 'confirm-delete',
    },
  },
};
</script>
